export const isExternalUrl = (value) => {
	if (typeof value !== "string") {
		return false;
	}

	const normalized = value.trim();
	if (!normalized) {
		return false;
	}

	return /^(https?:\/\/|ftp:\/\/|www\.)/i.test(normalized);
};

export const normalizeExternalUrl = (value) => {
	if (typeof value !== "string") {
		return "";
	}

	const normalized = value.trim();
	if (!normalized) {
		return "";
	}

	if (/^[a-z][a-z\d+\-.]*:\/\//i.test(normalized)) {
		return normalized;
	}

	if (/^www\./i.test(normalized)) {
		return `https://${normalized}`;
	}

	return normalized;
};
